import { Station } from "./station";
import { User } from "./user";

export class PPQTracking {
id : Number;
flight : String;
flightDate : Date;
route : String;
originId : Number;
destinationId : Number;
ppqstarted : Date;
ppqfinished : Date;
totalChangesStarted: number;
totalChangesFinished: number;
active : boolean;
createdUserId : Number;
createdDate : Date;
updatedUserId : Number;
updatedDate : Date;
origin : Station;
destination : Station;
updatedUser : User;
commodityFlowers: boolean;
changePpqStarted: boolean;
changePpqFinish: boolean;
}